import { render } from "./eventCreate.vue?vue&type=template&id=83ddd2ac"
import script from "./eventCreate.vue?vue&type=script&lang=js"
export * from "./eventCreate.vue?vue&type=script&lang=js"

import "./eventCreate.vue?vue&type=style&index=0&id=83ddd2ac&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__